module.exports = __webpack_public_path__ + "media/dashboard/assets/images/mobile-bell-203328d357184b6e83c722539aa4c07a.svg";